//Coty library for events and custom tracking
//@author terru
//ask Coty team for documentation
var Coty = (function (Coty) {
  //private functions
  function _defaultCallback(e) {
    console.log("Event hook");
    console.log("HOOKED EVENT!");
    console.log(e);
  }

  function _handle_error(e) {
    console.warn("Error on factory..");
    console.warn(e);
  }

  function _CotyException(message) {
    this.message = message;
    this.name = "CotyException";
  }

  function _parseYoutubeData(data) {
    var returner = {};
    var video = data.target.playerInfo;
    returner["videoName"] = video.videoData.title;
    returner["videoType"] = "youtube";
    returner["videoLength"] = video.duration;
    returner["videoUrl"] = video.videoUrl;
    returner["videotimePlayed"] = video.currentTime;
    return returner;
  }

  /**
   * Parse a pathname in a listing string for Coty
   * @param {*} location a result of window.location.pathname
   */
  function _parseLocation(location) {
    var listing_string = "home";
    //Coty enumerative alternatives:
    //  home|mini-cart|cart-view|product-page|collection-page|favorite|searchresult

    //parse the path to get the location name
    var regex = /\/\w+-*\w*/gi;

    var match_array = location.match(regex);

    var listing = Array.isArray(match_array) ? match_array[0] : "home";

    //transform path in Coty listin enumerative;
    if (listing === "/") {
      listing_string = "home";
    } else if (location == "cart") {
      //special case for mini cart
      listing_string = "mini-cart";
    } else if (/\/products/.test(location)) {
      listing_string = "product-page";
    } else if (listing === "/collections") {
      listing_string = "collection-page";
    } else if (listing === "/pages") {
      //check if is from favorites page
      listing_string = "favorite";
    } else if (listing === "/search") {
      listing_string = "searchresult";
    } else if (listing === "/cart") {
      listing_string = "cart-view";
    } else {
      listing_string = "home";
    }

    //return enumerative
    return listing_string;
  }

  function _parseProductData(externalData) {
    var productData = {};
    productData.sku = externalData.sku;
    productData.product_id = externalData.product_id;
    productData.name = externalData.product_title;
    productData.quantity = externalData.quantity;
    productData.type = externalData.product_type;
    var current_price = externalData.price;
    if (typeof externalData.price !== "string") {
      current_price = Math.round(externalData.price / 100).toFixed(2); //move to string and rounded as 2 decimals;
    } else {
      //use lineItem current price for UpdateQty methods
      current_price = Math.round(externalData.original_price / 100).toFixed(2);
    }
    productData.price = current_price;
    //same for total price
    productData.totalprice = Math.round(
      externalData.final_line_price / 100
    ).toFixed(2);
    if (
      externalData.added_quantity &&
      externalData.quantity !== externalData.added_quantity
    ) {
      productData.quantity = externalData.added_quantity;
      //needs to recalculate total price;
      var total_price =
        parseFloat(externalData.price) * parseInt(externalData.added_quantity);
      if (externalData.original_price) {
        //use current price instead
        total_price =
          parseFloat(externalData.original_price) *
          parseInt(externalData.added_quantity);
      }
      productData.totalprice = Math.round(total_price / 100).toFixed(2);
    }
    productData.listing = _parseLocation(externalData.location);
    productData.variant = {};
    for (prop of externalData.options_with_values) {
      //filter shopify variant default value
      if (prop.name !== "Title") {
        productData.variant[prop.name] = prop.value;
      }
    }
    return productData;
  }

  //event factory methods
  function _createMediaPlay(source, data) {
    var video_data;
    if (data) {
      //source has the video data
      video_data = data;
    } else {
      //retrieve data from an external source
      var $analyzed_object = $(source);
      var video_data = {
        videoName: $analyzed_object.attr("name"),
        videoType: $analyzed_object.children("source").attr("type"),
        videoLength: $analyzed_object.prop("duration"),
        videoURL: $analyzed_object.children("source").attr("src"),
        videotimePlayed: "0s",
        videoMilestone: "0",
      };
    }
    var detail = {
      eventInfo: {
        eventAction: "Video Media Play",
        eventName: "MediaPlay ",
        eventType: "userEvent",
        video: video_data,
      },
    };
    return new CustomEvent("MediaPlay", { detail: detail });
  }

  function _createMediaComplete(DomSelector, data) {
    //retrieved video data before (youtube)
    var video_data;
    if (data) {
      video_data = data;
    } else {
      //needs to retrieve video data
      var $analyzed_object = $(DomSelector);
      video_data = {
        videoName: $analyzed_object.attr("name"),
        videoType: $analyzed_object.children("source").attr("type"),
        videoLength: $analyzed_object.prop("duration"),
        videoURL: $analyzed_object.children("source").attr("src"),
        videotimePlayed: $analyzed_object.prop("currentTime"),
        videoMilestone: "100",
      };
    }
    var detail = {
      eventInfo: {
        eventAction: "Video Media Play",
        eventName: "MediaComplete",
        eventType: "userEvent",
        video: video_data,
      },
    };
    return new CustomEvent("MediaComplete", { detail: detail });
  }

  function _createMediaMilestone(MilestoneName, DomSelector, data) {
    var videoMilestone = MilestoneName.split("Media")[1];
    var video_data;
    if (data) {
      video_data = data;
    } else {
      var $analyzed_object = $(DomSelector);
      video_data = {
        videoName: $analyzed_object.attr("name"),
        videoType: $analyzed_object.children("source").attr("type"),
        videoLength: $analyzed_object.prop("duration"),
        videoURL: $analyzed_object.children("source").attr("src"),
        videotimePlayed: $analyzed_object.prop("currentTime"),
        videoMilestone: videoMilestone,
      };
    }
    var detail = {
      eventInfo: {
        eventAction: "Video Media Play",
        eventName: MilestoneName,
        eventType: "userEvent",
        video: video_data,
      },
    };
    return new CustomEvent(MilestoneName, { detail: detail });
  }

  /**
   * Generates miniCart Open Coty event
   * @doc even with info from Coty
   *   {
   *     detail: {
   *       eventInfo: {
   *       eventAction:"Mini Cart Loaded", //updated if the cart is already loaded
   *       eventName:"miniCart",
   *       eventType:"userEvent",
   *       currency:"usd|gbp|eur",
   *       listing:"mini-cart",
   *       cartId:"8888888", // set to swymCart token
   *       subtotal:"470.00||3000.00", // set to cart subtotal
   *       discount_code:"testcart", // set to discount code applied where applicable or return null
   *       cartInfo: [{
   *           //product1
   *           sku:"3614225113680", //set to the product sku
   *           product_id:"123", //set to the productid
   *           name:"makeup removing wipes",  // set to the product name
   *           quantity:"3", //set to the qty of items
   *           type:"wipes",  // set to the product category
   *           price:"10.00", //set to the base price of the item
   *           totalprice: "30.00", // set to the totalprice of the items
   *           },
   *           {//product2
   *           sku:"3714225113680", //set to the product sku
   *           product_id:"456", //set to the productid
   *           name:"makeup removing wipes",  // set to the product name
   *           quantity:"2", //set to the qty of item
   *           type:"wipes",  // set to the product category
   *           price:"10.00", //set to the base price of the item
   *           totalprice: "20.00", // set to the totalprice of items
   *        }]
   *     }
   *   }
   * @param {*} DomSelector
   * @param {*} externalData
   */
  function _createMiniCartOpen(eventAction, externalData) {
    var detail = {
      eventInfo: {
        eventAction: eventAction,
        eventName: "miniCart",
        eventType: "userEvent",
        currency: externalData.currency ? externalData.currency : "usd",
        listing: "mini-cart",
        cartId: externalData.token,
        subtotal: Math.round(externalData.total_price / 100).toFixed(2),
        discount_code: null, //TODO: check discount code on prod
        cartInfo: [],
      },
    };
    if (Array.isArray(externalData.items)) {
      for (item of externalData.items) {
        var to_add = {};
        to_add.sku = item.sku;
        to_add.product_id = item.product_id;
        to_add.name = item.product_title;
        to_add.quantity = item.quantity;
        to_add.type = item.product_type;
        to_add.price = item.price;
        to_add.totalprice = item.final_line_price;
        detail.eventInfo.cartInfo.push(to_add);
      }
    }

    //set discount code title if exists
    //@see https://shopify.dev/docs/themes/ajax-api/reference/cart#get-cart-js
    if (externalData.cart_level_discount_applications.length > 0) {
      detail.eventInfo.discount_code =
        externalData.cart_level_discount_applications[0].title;
    }

    return new CustomEvent("miniCartOpen", { detail: detail });
  }

  /**
   * Creates Add to Cart event for Coty when a product is added to the cart;
   * @param {*} DomSelector
   * @param {*} externalData
   * @doc Event generated using this reference from Coty;
   *       productInfo: {
   *       sku:"3614225113680", //set to the product sku of the item added
   *       product_id:"123", //set to the productid of the item added
   *       name:"makeup removing wipes",  // set to the product name of the item added.
   *       quantity:"1", //set to the qty of item added to the cart
   *       type:"wipes",  // set to the product category
   *       price:"10.00", //set to the base price of the item
   *       totalprice: "20.00", // set to the line-total of the item added to the cart
   *       listing:"home|mini-cart|cart-view|product-page|collection-page|favorite|searchresult" ,// set to the page where the addtocart action was triggered.
   *       variant: {
   *         size:"50ml",  //set where applicable
   *         colour:"extreme black" //set where applicable
   *       }
   *      }
   */
  function _createAddToCart(DomSelector, externalData) {
    var productData = {};
    if (externalData) {
      productData = _parseProductData(externalData);
    } else {
      var $analyzed_object = $(DomSelector);
      //TODO add support for DOm selector;
    }
    var detail = {
      eventInfo: {
        eventAction: "Add To Cart",
        eventName: "addtoCart",
        eventType: "userEvent",
        currency: externalData.currency ? externalData.currency : "usd"
      },
    };
    detail.eventInfo.productInfo = productData;
    return new CustomEvent("addtoCart", { detail: detail });
  }

  /**
   * Triggers remove from cart event
   * @param {*} DomSelector
   * @param {*} externalData
   * @doc from Coty
   * productInfo: {
   *    sku:"3614225113680", //set to the product sku of the item removed
   *    product_id:"123", //set to the productid of the item removed
   *    name:"makeup removing wipes",  // set to the product name of the item removed.
   *    quantity:"1", //set to the qty of item removed from the cart
   *    type:"wipes",  // set to the product category
   *    price:"10.00", //set to the base price of the item
   *    totalprice: "20.00", // set to the line-total of the item removed from the cart
   *    listing:"mini-cart|cart-view " ,// set to the page where the action was triggered.
   *    variant: {
   *      size:"50ml",  //set where applicable
   *      colour:"extreme black" //set where applicable
   *    }}
   */
  function _createRemoveFromCart(
    removeName,
    removeAction,
    DomSelector,
    externalData
  ) {
    var detail = {
      eventInfo: {
        eventAction: removeAction,
        eventName: removeName,
        eventType: "userEvent",
        currency: externalData.currency ? externalData.currency : "usd",
      },
    };
    var productData = {};
    if (externalData) {
      productData = _parseProductData(externalData);
    } else {
      var $analyzed_object = $(DomSelector);
      //TODO add support for DOm selector;
    }
    detail.eventInfo.productInfo = productData;
    return new CustomEvent(removeName, { detail: detail });
  }

  //public functions
  function checkSupport() {
    return typeof CustomEvent === "function";
  }

  //event Factory by Dom selector
  //signal a custom DOM event to be picked up by Adobe Analytics by Coty
  function createEvent(eventName, DomSelector, externalData) {
    try {
      //factory reflection
      var event, eventAction;
      if (eventName === "MediaPlay") {
        event = _createMediaPlay(DomSelector);
      } else if (eventName === "Media25") {
        event = _createMediaMilestone(eventName, DomSelector);
      } else if (eventName === "Media50") {
        event = _createMediaMilestone(eventName, DomSelector);
      } else if (eventName === "Media75") {
        event = _createMediaMilestone(eventName, DomSelector);
      } else if (eventName === "MediaComplete") {
        event = _createMediaComplete(DomSelector);
      } else if (eventName === "miniCartOpen") {
        eventAction = externalData.eventAction;
        event = _createMiniCartOpen(eventAction, externalData);
      } else if (eventName === "addtoCart") {
        event = _createAddToCart(DomSelector, externalData);
      } else if (eventName === "removefromCart") {
        eventAction = "Remove From Cart";
        event = _createRemoveFromCart(
          eventName,
          eventAction,
          DomSelector,
          externalData
        );
      } else if (eventName === "removeCart") {
        eventAction = "Remove Cart Item";
        event = _createRemoveFromCart(
          eventName,
          eventAction,
          DomSelector,
          externalData
        );
      } else {
        throw new _CotyException("No Coty event name");
      }
      console.log("SIGNALING:", event);
      document.body.dispatchEvent(event);
      return event;
    } catch (e) {
      _handle_error(e);
    }
  }

  //Youtube Event factory by youtube Data
  function createYoutubeEvent(eventName, youtubeData) {
    try {
      //factory
      var event;
      var data = _parseYoutubeData(youtubeData);
      if (eventName === "MediaPlay") {
        //milestone and timeplayed reset for play event;
        data.videoMilestone = "0";
        data.videotimePlayed = "0s";
        event = _createMediaPlay("youtube", data);
      } else if (eventName === "Media25") {
        data.videoMilestone = "25";
        event = _createMediaMilestone(eventName, "youtube", data);
      } else if (eventName === "Media50") {
        data.videoMilestone = "50";
        event = _createMediaMilestone(eventName, "youtube", data);
      } else if (eventName === "Media75") {
        data.videoMilestone = "75";
        event = _createMediaMilestone(eventName, "youtube", data);
      } else if (eventName === "MediaComplete") {
        data.videoMilestone = "100";
        event = _createMediaComplete("youtube", data);
      } else {
        throw new _CotyException("No Coty event name");
      }
      console.log("Youtube event SIGNALING:", event);
      document.body.dispatchEvent(event);
      return event;
    } catch (e) {
      _handle_error(e);
    }
  }

  function hookEvent($object, eventName, eventHook) {
    if (typeof eventHook === "function") {
      $object.on(eventName, eventHook);
    } else {
      $object.on(eventName, _defaultCallback);
    }
  }

  return {
    checkSupport: checkSupport,
    createEvent: createEvent,
    createYoutubeEvent: createYoutubeEvent,
    hookEvent: hookEvent,
  };
})(navigator.Coty);

//@usage
// if (Coty.checkSupport()) {
//Coty.createEvent();
// } else {
//   console.log("CotyEvents are not supported for this Browser/OS.");
// }
